import { FC, ReactNode } from 'react';
import { cva, VariantProps } from 'class-variance-authority';
import { DivProps } from 'react-html-props';
import clsx from 'clsx';

interface Props extends DivProps, VariantProps<typeof cvaRoot> {
  children: ReactNode;
  icon?: ReactNode;
  iconAfter?: ReactNode;
  onClickIconAfter?: () => void;
}

const Tag: FC<Props> = ({
  children,
  className,
  icon,
  iconAfter,
  size = 'md',
  theme,
  onClickIconAfter,
  ...props
}) => {
  return (
    <div className={clsx(cvaRoot({ theme, size }), className)} {...props}>
      {icon}
      <div
        className={clsx(
          iconAfter && size == 'lg' ? 'pl-0.8' : '',
          'whitespace-nowrap'
        )}>
        {children}
      </div>
      <div className={'empty:hidden'} onClick={onClickIconAfter}>
        {iconAfter}
      </div>
    </div>
  );
};

const cvaRoot = cva(
  [
    'Tag-cvaRoot',
    'flex items-center',
    'px-1.2',
    'border-2',
    'rounded-[2.4rem] font-semibold duration-300',
    'cursor-pointer',
  ],
  {
    variants: {
      theme: {
        outline: 'border-cGray700',
        blurred: 'bg-cBlurred border-transparent',
        active: 'border-cPurple900 bg-black shadow-menu',
      },
      size: {
        lg: 'h-4.8 gap-0.8',
        md: 'h-4 gap-0.4',
      },
    },
    defaultVariants: {
      theme: 'outline',
    },
  }
);

export default Tag;
